export default __webpack_public_path__ + "static/media/020_start.hevc.e280cd0e.mp4";